var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCasaLupitaHorizLogo = function SvgCasaLupitaHorizLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 206.37 41.38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-lg",
    x1: 38.37,
    y1: 22.96,
    x2: 197.29,
    y2: 22.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e46929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e5ab40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e46929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-lg-2",
    x1: 38.37,
    y1: 23.02,
    x2: 197.29,
    y2: 23.02,
    xlinkHref: "#h-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-lg-6",
    x1: 38.37,
    y1: 23.22,
    x2: 197.29,
    y2: 23.22,
    xlinkHref: "#h-lg"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-lg-7",
    x1: 38.54,
    y1: 23.02,
    x2: 197.46,
    y2: 23.02,
    xlinkHref: "#h-lg"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.43,
    y: 29.74,
    width: 1.46,
    height: 11.21,
    rx: 0.73,
    fill: "#6e6f72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.88,
    y: 34.02,
    width: 0.33,
    height: 2.94,
    fill: "#6e6f72"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 34.94,
    width: 0.4,
    height: 1.24,
    fill: "#6e6f72"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.87,
    y: 29.74,
    width: 1.46,
    height: 11.21,
    rx: 0.73,
    transform: "translate(55.2 70.68) rotate(-180)",
    fill: "#6e6f72"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.55,
    y: 34.02,
    width: 0.33,
    height: 2.94,
    transform: "translate(53.43 70.99) rotate(-180)",
    fill: "#6e6f72"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.15,
    y: 34.81,
    width: 0.4,
    height: 1.24,
    transform: "translate(52.69 70.86) rotate(180)",
    fill: "#6e6f72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.88,13.59a3.57,3.57,0,1,0,3.52,3.57A3.54,3.54,0,0,0,17.88,13.59Zm0,5.28a1.71,1.71,0,1,1,1.71-1.71A1.71,1.71,0,0,1,17.88,18.87Z",
    fill: "#fbb437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88,5.75a4.11,4.11,0,1,0,4,4.11A4.08,4.08,0,0,0,8.88,5.75Zm0,6.06a2,2,0,1,1,1.95-2A1.95,1.95,0,0,1,8.88,11.81Z",
    fill: "#b73329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.92,0a4.48,4.48,0,0,0-4.44,4.51,4.45,4.45,0,1,0,8.89,0A4.48,4.48,0,0,0,18.92,0Zm0,6.59A2.09,2.09,0,1,1,21,4.51,2.08,2.08,0,0,1,18.92,6.59Z",
    fill: "#005779"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48,41.24a.14.14,0,0,1-.2.12C-.63,39.9.1,37.17,0,34.39c0-3.66,0-6.1.13-11.12-.08-5.95,7.24-10.4,12.4-7.22a.13.13,0,0,1,.06.11c0,.36,0,1.95,0,2.65a.14.14,0,0,1-.23.1C9.1,16,2.63,18.07,2.6,23.32,2.43,30.39,2.49,34.94,2.48,41.24Z",
    fill: "#b83125"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.93,19.11v0a0,0,0,0,0,0,0",
    fill: "#c82128"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,9.72A.15.15,0,0,1,22,9.58a8.18,8.18,0,0,1,7.72,8.1c.11,4.85.14,5.5.13,8.82a.14.14,0,0,1-.24.09l-2.3-2.48a.16.16,0,0,1,0-.09V17.73a5.49,5.49,0,0,0-5.32-5.55.12.12,0,0,1-.12-.13Z",
    fill: "#005779"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.16,29.89a7.79,7.79,0,0,0-4.41-6.62h0a8.26,8.26,0,0,0-7.73,0h0a7.82,7.82,0,0,0-4.41,6.63c-.11,4.6-.14,5.66-.12,9v.31a1.21,1.21,0,0,0,2.42,0V38.9c0-3.34,0-4.38.12-9a5.59,5.59,0,0,1,3.17-4.72,6,6,0,0,1,2.7-.69,6,6,0,0,1,2.69.69,5.59,5.59,0,0,1,3.17,4.72c.11,4.58.14,5.62.12,9v.31a1.22,1.22,0,0,0,2.43,0v-.3C26.3,35.55,26.27,34.49,26.16,29.89Z",
    fill: "#fbb437"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.41,26.08a7.66,7.66,0,0,1-2.6,5.43,9.66,9.66,0,0,1-6.24,1.9q-4.5,0-6.86-2.71T39.34,23q0-5.19,2.42-7.79c1.66-1.81,4-2.71,7.16-2.71A9.07,9.07,0,0,1,55,14.42a7.45,7.45,0,0,1,2.43,5.2H54.92a2,2,0,0,1-2-1.22,5.66,5.66,0,0,0-1-1.32,5,5,0,0,0-3.06-.87,5,5,0,0,0-4.1,1.73A8,8,0,0,0,43.44,23a7.82,7.82,0,0,0,1.38,5,4.66,4.66,0,0,0,4,1.78,4.83,4.83,0,0,0,3-.92,4.82,4.82,0,0,0,1.56-2.77Z",
    fill: "url(#h-lg)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.22,13.09h3.23L76.67,33H72.34L71,28.85H63.28L62,33H57.68l6.58-18.53A2,2,0,0,1,66.22,13.09Zm.93,4L64.37,25.5h5.55Z",
    fill: "url(#h-lg-2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.41,26.77h4a3.16,3.16,0,0,0,1.33,2.43A5.43,5.43,0,0,0,85,30a4.8,4.8,0,0,0,2.71-.64,2.1,2.1,0,0,0,.93-1.85q0-1.85-5.2-3l-.11-.06-.46-.11A11.92,11.92,0,0,1,78.89,23a3.4,3.4,0,0,1-1.61-1.85,5.33,5.33,0,0,1-.58-2.65,5.43,5.43,0,0,1,2-4.44,9,9,0,0,1,5.71-1.56,8.2,8.2,0,0,1,5.43,1.61,6.44,6.44,0,0,1,2.08,4.68H89.57a2,2,0,0,1-1.91-1.21,2.81,2.81,0,0,0-.8-1A4.77,4.77,0,0,0,84,15.87a3.85,3.85,0,0,0-2.48.63,2.08,2.08,0,0,0-.87,1.79c0,1,1.12,1.81,3.35,2.31a9.09,9.09,0,0,0,1.44.34c.69.23,1.3.42,1.82.55l1.24.32,1.62.69a5,5,0,0,1,1.78,1.79A5.56,5.56,0,0,1,92.57,27a5.94,5.94,0,0,1-2.08,4.84,9.37,9.37,0,0,1-5.88,1.62q-3.93,0-5.89-1.67A6.38,6.38,0,0,1,76.41,26.77Z",
    fill: "url(#h-lg)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33,13.09h3.23L111.77,33h-4.32l-1.33-4.1H98.38L97.12,33H92.79l6.58-18.53A1.94,1.94,0,0,1,101.33,13.09Zm.92,4L99.48,25.5H105Z",
    fill: "url(#h-lg-2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34,33V15.17a2,2,0,0,1,.6-1.47,2,2,0,0,1,1.47-.61h2V29.25h9.7V33Z",
    fill: "url(#h-lg-2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.51,13V25.45a5.43,5.43,0,0,0,.87,3.4,3.74,3.74,0,0,0,2.94,1,3.86,3.86,0,0,0,2.94-1,5,5,0,0,0,.93-3.4V13h4.09V25.91a7.24,7.24,0,0,1-2.07,5.6c-1.27,1.27-3.24,1.9-5.89,1.9s-4.62-.63-5.89-1.9a7.24,7.24,0,0,1-2.08-5.6V15.23A2.22,2.22,0,0,1,135,13.7a1.93,1.93,0,0,1,1.47-.66Z",
    fill: "url(#h-lg-6)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.9,25.85V33h-4.1V15.17a2,2,0,0,1,.6-1.47,2,2,0,0,1,1.48-.61h6.75a6.29,6.29,0,0,1,4.73,1.62A6.5,6.5,0,0,1,167,19.5a6.8,6.8,0,0,1-1.56,4.73,6,6,0,0,1-4.5,1.62Zm0-3.58h4a3.19,3.19,0,0,0,2.31-.69,2.75,2.75,0,0,0,.75-2.19,3.18,3.18,0,0,0-.69-2.14,3.2,3.2,0,0,0-2.14-.69H155.9Z",
    fill: "url(#h-lg-7)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.32,33V15.17a2,2,0,0,1,.61-1.47,2,2,0,0,1,1.47-.61h2V33Z",
    fill: "url(#h-lg-7)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.66,33V16.62h-5.89V15.17a2,2,0,0,1,.61-1.47,2,2,0,0,1,1.47-.61h13.74v3.53h-5.83V33Z",
    fill: "url(#h-lg-7)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.92,13.09h3.23L206.37,33H202l-1.33-4.1H193L191.71,33h-4.33L194,14.42A2,2,0,0,1,195.92,13.09Zm.93,4-2.77,8.42h5.54Z",
    fill: "url(#h-lg-7)"
  })));
};

export default SvgCasaLupitaHorizLogo;